import { createSelector } from "@ngrx/store";

import { AppState } from "./app.state";
import { UserAccountHomeDto } from "../core/dtos/dto";

export const selectMyAccount = createSelector(
  (state: AppState) => state.myAccount,
  (myAccount: UserAccountHomeDto) => myAccount
);

export const selectIsBusinessAccount = createSelector(
  selectMyAccount,
  (myAccount: UserAccountHomeDto) => myAccount?.linkedToActiveBusinessAccount
);

export const selectChildTermName = createSelector(
  selectMyAccount,
  (myAccount: UserAccountHomeDto) => myAccount?.businessAccountTypeNameMapping.childTermName
);

export const selectParentTermName = createSelector(
  selectMyAccount,
  (myAccount: UserAccountHomeDto) => myAccount?.businessAccountTypeNameMapping.parentTermName
);

export const selectBusinessAccountTypeNameMapping = createSelector(
  selectMyAccount,
  (myAccount: UserAccountHomeDto) => myAccount?.businessAccountTypeNameMapping
);
